import { WatchDialogQueryWithWatchChildren } from './WatchDialogQuery.graphql';

export const getWatchDialogQuery = () => {
	return WatchDialogQueryWithWatchChildren;
};
